import axios, { getAuthHeaders } from "./config";

export default {
    get: function (obj) {
        let eventUrl = "";
        let userUrl = "";
        for (let i=0; i <= obj.filterBy.events.length - 1; i++) {
            eventUrl = `${eventUrl}event[${i}]=${obj.filterBy.events[i]}&`;
        }
        for (let i=0; i <= obj.filterBy.users.length - 1; i++) {
            userUrl = `${userUrl}user_id[${i}]=${obj.filterBy.users[i].id}&`;
        }
        if (obj.filterBy.date_to !== "") {
            return axios.get(`/logs/${obj.perPage}?page=` + obj.page +
                `&${eventUrl}`+
                `&${userUrl}` +
                `description=` + obj.filterBy.description +
                `&between=created_at,` + obj.filterBy.date_from + `,` + obj.filterBy.date_to, {
                headers: getAuthHeaders()
            });
        }
        return axios.get(`/logs/${obj.perPage}?page=` + obj.page +
            `&${eventUrl}`+
            `${userUrl}` +
            `description=` + obj.filterBy.description +
            `&like=created_at,` + obj.filterBy.date_from, {
            headers: getAuthHeaders()
        });
    },
    Listlogs: function () {
        return axios.get("/count-logs", {
            headers: getAuthHeaders()
        });
    },
    logsGrouped: function () {
        return axios.get("/logs", {
            headers: getAuthHeaders()
        });
    },
    latestDocument: function() {
        return axios.get("/latest-documents", {
            headers: getAuthHeaders()
        });
    }
}